import { isRouteErrorResponse, useRouteError } from "react-router";

import { Button } from "@rai/ui/button";
import { siteConfig } from "@rai/core/lib/site";
import { NotFound } from "./not-found";

/**
 * A page failed to render or its code failed to load. After a deploy, an open
 * tab can ask for a page chunk that no longer exists; reloading fetches the
 * new build.
 */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  return (
    <main id="main-content" tabIndex={-1} className="page-container flex min-h-screen flex-col items-center justify-center bg-stone-50 py-20 text-center">
      <h1 className="text-2xl font-medium tracking-[-0.02em] text-stone-950">This page couldn&apos;t open</h1>
      <p className="mt-2 text-sm text-stone-600">
        Reload to try again, or call <a href={siteConfig.phone.href} className="font-medium text-stone-900 underline underline-offset-4">{siteConfig.phone.display}</a> and we&apos;ll help directly.
      </p>
      <div className="mt-6 flex justify-center gap-2">
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </main>
  );
}
